const { lazy } = require('react')

export const AdminPageAsync = lazy(() => import('./AdminPage'))
